
import * as api from "../constant/NewAPI";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Utils from "../constant/Utils";
import Swal from "sweetalert2";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";

// import * as api from "../constant/API";

const AcademicAttendance = () => {

    const roleId = localStorage.getItem("RoleId");

    const [searchInput, setSearchInput] = useState("");
    const [attendanceList, setAttendanceList] = useState([]);
    const [atndcName, setAtndcName] = useState("");
    const [atndcDescription, setAtndcDescription] = useState("");
    const [atndcId, setAtndcId] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const formRef = useRef(null);

    // if (roleId === "1") {
    useEffect(() => {
        atndcList()
    }, [])
    // }

    function atndcList() {
        const getAttendanceList = api.adminAttendanceList;
        fetch(getAttendanceList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                // console.log(result.data)
                setAttendanceList(result.data);
            })
            .catch((error) => {
                console.log("Failed to fetch attendance list", error);
            })
    }

    const filteredData = attendanceList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value.toString().toLowerCase()
        );
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editAttendance(rowData)}>
                <i className="feather-edit" />
                Edit
            </Link>
        );
    };

    const slNoRender = (rowData) => {
        return <span>{rowData.attendanceTypeId}</span>;
    };

    const nameRender = (rowData) => {
        return <span>{rowData.attendanceTypeName}</span>;
    };

    const descriptionRender = (rowData) => {
        return <span>{rowData.attendanceDescription}</span>
    }

    function newAttendance() {
        setOpenModal(true);
        setIsEdit(false);
        setAtndcName("");
        setAtndcDescription("");
    }

    function editAttendance(selectedRow) {
        const atndid = selectedRow.attendanceTypeId;

        const atndcDetails = api.adminAttendanceDetails + '/' + atndid// '?attendanceTypeId=' + atndid;
        fetch(atndcDetails, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((atndcResponse) => atndcResponse.json())
            .then((atndcResult) => {
                const dta = atndcResult.data;
                setAtndcId(dta.attendanceTypeId);
                setAtndcName(dta.attendanceTypeName);
                setAtndcDescription(dta.attendanceDescription);
                setIsEdit(true)
                setOpenModal(true)
            })
            .catch((error) => {
                console.log("Failed to fetch the attendance details", error)
            })
    }

    function addAttendance(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateAttendance()
            }
            else {
                const formData = new FormData();
                formData.append('attendanceTypeName', atndcName);
                formData.append('attendanceDescription', atndcDescription);

                const atndcAdd = api.adminAttendanceCreate;
                fetch(atndcAdd, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        } else {
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        }
                    })
            }
            setOpenModal(false)
        }
    }

    function updateAttendance() {
        const formData = new FormData();
        formData.append('attendanceTypeId', atndcId);
        formData.append('attendanceTypeNameEdit', atndcName);
        formData.append('attendanceDescriptionEdit', atndcDescription);

        const atndcUpdate = api.adminAttendanceUpdate;
        fetch(atndcUpdate, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((updateResponse) => updateResponse.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    return (
        <>
            <div className="row">
                <div className="col-sm-12">
                    <div className="court-tab-content">
                        <div className="card card-tableset">
                            <div className="card-body">
                                <div className="coache-head-blk">
                                    <div className="row align-items-center">
                                        {roleId == 1 ? (
                                            <>
                                                <div className="row col-lg-12">
                                                    <div className="col-lg-4">
                                                        <Link
                                                            to="#"
                                                            className="btn btn-secondary"
                                                            onClick={newAttendance}>
                                                            <i className="feather-plus" />&nbsp;
                                                            Add Attendance Type
                                                        </Link>
                                                    </div>
                                                </div>
                                            </>
                                        ) : null}
                                        <div className="col-md-6">
                                        </div>
                                        <div className="col-md-6">
                                            <div className="dataTables_filter">
                                                <label>
                                                    <input
                                                        type="text"
                                                        value={searchInput}
                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                        placeholder="Search"
                                                        className="form-control"
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50]}
                                                currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            >
                                                <Column
                                                    sortable
                                                    field="schedulesId"
                                                    body={slNoRender}
                                                    header="Sl No"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="schedulesName"
                                                    body={nameRender}
                                                    header="Group Name"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="schedulesDescription"
                                                    body={descriptionRender}
                                                    header="Description"
                                                ></Column>
                                                <Column
                                                    body={editDetails}
                                                ></Column>
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add/ Edit Attendance */}
            <Modal
                show={openModal}
                size="md"
                centered
            >
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case"><i className="feather-plus" />{isEdit ? "Edit " : "Add "}Attendance Type</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="col-lg-12">
                            <div className="input-space">
                                <label className="form-label">Attendance Name</label>
                                <input
                                    id="batchName"
                                    className="form-control"
                                    style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                    value={atndcName}
                                    required
                                    onChange={(e) => {
                                        setAtndcName(e.target.value)
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="input-space">
                                <label className="form-label">Attendance Description</label>
                                <textarea
                                    id="batchName"
                                    className="form-control"
                                    style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                    value={atndcDescription}
                                    required
                                    onChange={(e) => {
                                        setAtndcDescription(e.target.value)
                                    }}
                                />
                            </div>
                        </div>
                    </form>
                </ModalBody>
                <ModalFooter>
                    <Button
                        className="btn-primary text-uppercase"
                        type="submit"
                        variant="success"
                        onClick={addAttendance}
                        data-bs-dismiss="modal" aria-label="Close"
                    >
                        <b><i className="fas fa-save" />{isEdit ? "Update" : "Save"}</b>
                    </Button>
                </ModalFooter>
            </Modal>
            {/* /Edit Schedule */}
        </>
    );
};

export default AcademicAttendance;